import script from "./user-select.vue?vue&type=script&setup=true&lang=js"
export * from "./user-select.vue?vue&type=script&setup=true&lang=js"

import "./user-select.vue?vue&type=style&index=0&id=0248ead0&lang=scss"

const __exports__ = script;

export default __exports__